<div class="wrapper">
<iframe *ngIf="launchUrl" width="100%" height="100%" [src]="launchUrl" title="myIframe"  id="my-iframe"  #iframeObj></iframe>
</div>
